// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.language-selector--dropdown .p-dropdown {
  box-shadow: 0px 1px 8px rgba(0, 0, 0, 0.08), 0px 3px 4px rgba(0, 0, 0, 0.1), 0px 1px 4px -1px rgba(0, 0, 0, 0.1);
}
.language-selector--dropdown .p-dropdown-trigger {
  width: auto;
  margin-right: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/app/main/apps/components/language-selector/language-selector.component.scss"],"names":[],"mappings":"AACI;EACI,gHAAA;AAAR;AAKI;EACI,WAAA;EACA,oBAAA;AAHR","sourcesContent":[".language-selector--dropdown {\n    .p-dropdown {\n        box-shadow: 0px 1px 8px rgba(0, 0, 0, 0.08),\n            0px 3px 4px rgba(0, 0, 0, 0.1),\n            0px 1px 4px -1px rgba(0, 0, 0, 0.1);\n    }\n\n    .p-dropdown-trigger {\n        width: auto;\n        margin-right: .5rem;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
